import React, { useEffect, useRef, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import SelectExpirationDates from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/ExpirationDates';
import RenderOptionChains, {
  CreateSubscriptionForOptionChains,
  useOptionShortCutEffect,
} from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/OptionChains';
import DisplayOptionChoices from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/DisplayOptionChoices';
import OptionChainStrategyCheckboxes from './OptionChainStrategyCheckboxes';
import OptionsFiltersTree from '../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/OptionFilters';
import { FormControlLabel, Typography } from '@material-ui/core';
import StyledCheckbox from '../../../../../utils/componentutils/StyledCheckbox';

export default function OptionControls({
  setExpirationDates,
  symbolsUsed,
  setSymbolsUsed,
  setOptionChains,
  maxOptionPriceBarrier,
  setMaxOptionPriceBarrier,
  minOptionPriceBarrier,
  setMinOptionPriceBarrier,
  setOptionChoices,
  optionChains,
  tightSpreadPctEnabled,
  setTightSpreadPctEnabled,
  tightSpreadPct,
  dispatchTightSpreadPct,
  optionPriceRangeEnabled,
  optionPriceRange,
  setOptionPriceRangeEnabled,
  dispatchOptionPriceRange,
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain,
  top,
  expirationDates,
  notExpiringToday,
  optionChoices,
  selectAll,
  callType,
  putType,
  otm1Enabled,
  setOtm1Enabled,
  hugCurrentPriceEnabled,
  setHugCurrentPriceEnabled,
  itm1Enabled,
  setItm1Enabled,
  dispatchOtm1,
  dispatchItm1,
  dollarRangeEnabled,
  dollarRange,
  qtyRange,
  qtyRangeEnabled,
  tightSpreadCentsEnabled,
  tightSpreadCents,
  otmEnabled,
  itmEnabled,
  entryTactics,
  setNotExpiringToday,
  optionsAvailable,
  setOptionsAvailable,
  ds,
  symbol,
  goLong,
  goShort,
}) {
  //console.log(optionShortCutsPackage);
  const prevSymbolRef = useRef('');
  const prevDsRef = useRef('');
  const prevExpirationDatesRef = useRef('');
  const prevGoLongRef = useRef(false);
  const prevGoShortRef = useRef(false);
  const prevSelectAllRef = useRef(false);
  const prevCallTypeRef = useRef('');
  const prevPutTypeRef = useRef('');
  const optionChainKeys = useRef('');

  let optionShortCutRefs = [
    prevSymbolRef,
    prevDsRef,
    prevExpirationDatesRef,
    prevGoLongRef,
    prevGoShortRef,
    prevSelectAllRef,
    prevCallTypeRef,
    prevPutTypeRef,
    optionChainKeys,
  ];

  useOptionShortCutEffect(
    optionChains,
    optionChoices,
    setOptionChoices,
    selectAll,
    callType,
    putType,
    finishedRenderingOptionChain,
    setFinishedRenderingOptionChain,
    symbol,
    ds,
    goLong,
    goShort,
    expirationDates,
    optionShortCutRefs
  );
  useEffect(() => {
    //jStat()
    const convertToSpreads = async (optionChains, optionChoices) => {
      const spreads = [];
      const chainAsObject = {};
      if (Object.keys(optionChains).length > 0) {
        Object.values(optionChains['chains']).forEach((chain) => {
          Object.values(chain).forEach((options) => {
            Object.values(options).forEach((o) => {
              let option = o; /*  JSON.parse(o); */
              chainAsObject[option.symbol] = option;
            });
          });
        });
      }
      //   console.log(chainSpreads);
      let best = 1000; //.. as iterate through here...
      // console.log(optionChoices);

      let qtyBasisValue = 0;
      if (entryTactics['MARKET_ORDER'] !== undefined) {
        qtyBasisValue = entryTactics['MARKET_ORDER']['quantityBasisValue'];
      } else if (entryTactics['LIMIT_ORDER'] !== undefined) {
        qtyBasisValue = entryTactics['LIMIT_ORDER']['quantityBasisValue'];
      } else if (entryTactics['CANDLE_BREAK'] !== undefined) {
        qtyBasisValue = entryTactics['CANDLE_BREAK']['quantityBasisValue'];
      }
      let passFilterCount = 0;
      let choices = optionChoices.choices;
      for (let i in choices) {
        let expireDate = choices[i];
        for (let index in expireDate) {
          let oc = expireDate[index];
          let option = chainAsObject[oc];
          if (option === undefined) {
            continue;
          }
          let passesFilters = true;
          if (tightSpreadPctEnabled) {
            let spread = tightSpreadPct.maxOptionSpreadPct;
            let optionSpread = (option.ask - option.bid) / option.ask;
            if (optionSpread > spread) {
              passesFilters = false;
            }
          }
          if (otmEnabled) {
            //believe option chain message has quote;
            let quote = optionChains.quote;
            let midQuotePrice = (quote.bid + quote.ask) / 2;
            if (option.strike < midQuotePrice) {
              passesFilters = false;
            }
          }
          if (itmEnabled) {
            let quote = optionChains.quote;
            let midQuotePrice = (quote.bid + quote.ask) / 2;
            if (option.strike > midQuotePrice) {
              passesFilters = false;
            }
          }
          if (tightSpreadCentsEnabled) {
            let cents = tightSpreadCents.maxOptionSpreadCents;
            let optionCents = option.ask - option.bid;
            if (optionCents > cents) {
              passesFilters = false;
            }
          }
          if (optionPriceRangeEnabled) {
            let mid = (option.bid + option.ask) / 2;
            if (
              mid <= optionPriceRange.minPrice ||
              mid >= optionPriceRange.maxPrice
            ) {
              passesFilters = false;
            }
          }

          if (dollarRangeEnabled) {
            let min = dollarRange.minDollar;
            let max = dollarRange.maxDollar;
            let mid = (option.bid + option.ask) / 2;
            let expectedDollar = qtyBasisValue * mid * 100;
            if (expectedDollar <= min || expectedDollar >= max) {
              passesFilters = false;
            }
          }
          if (qtyRangeEnabled) {
            let min = qtyRange.minQty;
            let max = qtyRange.maxQty;
            let mid = (option.bid + option.ask) / 2;
            let expectedQty = qtyBasisValue / mid / 100;
            if (expectedQty <= min || expectedQty >= max) {
              passesFilters = false;
            }
          }
          if (passesFilters) {
            passFilterCount++;
          }
        }
      }
      return { count: passFilterCount };
    };
    convertToSpreads(optionChains, optionChoices).then((stats) => {
      setOptionsAvailable(stats.count);
      //console.log(stats.count);
    });
  }, [
    optionChoices,
    optionChains,
    tightSpreadPct,
    tightSpreadPctEnabled,
    tightSpreadCents,
    tightSpreadCentsEnabled,
    qtyRangeEnabled,
    qtyRange,
    dollarRange,
    dollarRangeEnabled,
    optionPriceRangeEnabled,
    optionPriceRange,
    otmEnabled,
    itmEnabled,
    entryTactics,
  ]);
  return (
    <div className={'m-2'}>
      <Grid container>
        <Grid item xs={false}>
          <SelectExpirationDates
            symbol={top.symbol}
            brokerage={top.brokerage}
            dataSource={top.dataSource}
            expirationDates={expirationDates}
            setExpirationDates={setExpirationDates}
            notExpiringToday={notExpiringToday}
            symbolsUsed={symbolsUsed}
            setSymbolsUsed={setSymbolsUsed}
            isMulti={true}
            numOfDefaultSelected={2}
            setOptionChains={setOptionChains}
            startingIndex={0}
            showStrikesMessage={false}
            highBarrier={maxOptionPriceBarrier}
            setHighBarrier={setMaxOptionPriceBarrier}
            lowBarrier={minOptionPriceBarrier}
            setLowBarrier={setMinOptionPriceBarrier}
            hideSelect={true}
            //fetch={props.fetch}
          />
        </Grid>
        <Grid item xs={4}>
          <RenderOptionChains
            top={top}
            expirationDates={expirationDates}
            optionChoices={[optionChoices, setOptionChoices]}
            setSymbolsUsed={setSymbolsUsed}
            optionChains={[optionChains, setOptionChains]}
            selectSingle={false}
            displayOptionComponent={DisplayOptionChoices}
            tightSpread={[
              tightSpreadPctEnabled,
              tightSpreadPct,
              dispatchTightSpreadPct,
            ]}
            optionPriceRange={[
              optionPriceRangeEnabled,
              optionPriceRange,
              dispatchOptionPriceRange,
            ]}
            showSelectedOptions={false}
          />
        </Grid>
        <Grid item xs={false}>
          <CreateSubscriptionForOptionChains
            symbol={top.symbol}
            brokerage={top.brokerage}
            dataSource={top.dataSource}
            expirationDates={expirationDates}
            optionChains={[optionChains, setOptionChains]}
            finishedRenderingOptionChain={finishedRenderingOptionChain}
            setFinishedRenderingOptionChain={setFinishedRenderingOptionChain}
          />
        </Grid>
        <Grid item xs={2}>
          <FormControlLabel
            control={<StyledCheckbox />}
            checked={notExpiringToday}
            onClick={(ev) => setNotExpiringToday(ev.target.checked)}
            label={<Typography style={{ fontSize: 8 }}>NotToday</Typography>}
            labelPlacement={'top'}
          />
        </Grid>
        <Grid item xs={6}>
          <OptionChainStrategyCheckboxes
            otm1Enabled={otm1Enabled}
            setOtm1Enabled={setOtm1Enabled}
            itm1Enabled={itm1Enabled}
            setItm1Enabled={setItm1Enabled}
            hugCurrentPriceEnabled={hugCurrentPriceEnabled}
            setHugCurrentPriceEnabled={setHugCurrentPriceEnabled}
            dispatchItm1={dispatchItm1}
            dispatchOtm1={dispatchOtm1}
          />
        </Grid>
        {/* <Grid item xs={9}>
                <OptionShortCutsCheckBoxes
                    optionShortCutsPackage={optionShortCutsPackage}
                    highBarrier={maxOptionPriceBarrier}
                    lowBarrier={minOptionPriceBarrier}
                    optionChoices={optionChoices}
                    setOptionChoices={setOptionChoices}
                    optionChains={optionChains}
                    finishedRenderingOptionChain={finishedRenderingOptionChain}
                    setFinishedRenderingOptionChain={setFinishedRenderingOptionChain}
                    showAllOptionsSelect={false}
                    labelPlacement={"top"}
                />
            </Grid>*/}
      </Grid>
    </div>
  );
}
